import { configureStore } from '@reduxjs/toolkit';
import { isMobile } from 'react-device-detect';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { io } from 'socket.io-client';
import { v4 } from 'uuid';

import { accountsSlice } from '../Components/Accounts/slice';
import { calendarSlice } from '../Components/Calendar/slice';
import { deliveryPaperSlice } from '../Components/DeliveryPaper/slice';
import { formsSlice, saveState as saveFormsState } from '../Components/Forms/slice';
import { authSlice } from './firebase';

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    accounts: accountsSlice.reducer,
    currentForm: formsSlice.reducer,
    deliveryPaper: deliveryPaperSlice.reducer,
    calendar: calendarSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

declare global {
  interface Window {
    windowId: string | undefined;
    socket: ReturnType<typeof io> | undefined;
  }
}

window.windowId = window.localStorage.getItem("window-id") || undefined;

if (!window.windowId) {
  window.windowId = v4();
  window.localStorage.setItem("window-id", window.windowId);
}

setInterval(
  () => {
    const state = store.getState();
    const wsUrl = state.auth.userdata?.wsUrl;

    if (wsUrl && !window.socket) {
      window.socket = io(wsUrl);

      window.socket.on("connect", () => {
        console.log("ws-connected: store");
      });

      window.socket.on("disconnect", () => {
        console.log("ws-disconnected: store");
      });
    }

    if (window.socket?.connected) {
      const editingFormData =
        state.currentForm.newForms[state.currentForm.editingNewFormUUID];

      if (
        editingFormData &&
        editingFormData.editorWindowId === window.windowId
      ) {
        window.socket.emit(
          "form-data",
          window.windowId,
          state.currentForm.editingNewFormUUID,
          JSON.stringify(editingFormData)
        );
      }
    }

    saveFormsState(state);
  },
  isMobile ? 1500 : 5000
);
